import { $Color } from '@suntex.core/types';

import { NodeModel } from '../../../types';
import { bonusNode } from '../areas/bonus';
import { ctNode } from '../areas/ct';
import { gymsNode } from '../areas/gyms';
import { jtfNode } from '../areas/jtf';
import { k2Node } from '../areas/k2';
import { ksNode } from '../areas/ks';
import { mwNode } from '../areas/mw';
import { ssNode } from '../areas/ss';
import { vifNode } from '../areas/vif';

export const modulesNode = {
  tag: 'modules',
  icon: 'fim',
  label: 'All modules',
  color: $Color.from('#5645da'),
  hideProgressBar: true,
  layout: 'clock',
  children: [
    jtfNode,
    vifNode,
    gymsNode,
    ssNode,
    ksNode,
    bonusNode,
    mwNode,
    ctNode,
    k2Node,
  ],
} satisfies NodeModel;
